import { render } from "./ZoomSettings.vue?vue&type=template&id=6d4ac985"
import script from "./ZoomSettings.vue?vue&type=script&lang=js"
export * from "./ZoomSettings.vue?vue&type=script&lang=js"

import exportComponent from "/home/nucleares/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__